module.exports = __webpack_public_path__ + "static/media/alibaba-cloud.51dacd77.jpg";